// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1pwPD","content":"GlobalSearch_content__1eYqs"};